import { Component, ViewChild, TemplateRef, ElementRef, Renderer2, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { messageService } from 'src/app/message.service';
import { qmsService } from '../../qms.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { PaginationService } from 'src/app/PaginationService';
import { forkJoin } from 'rxjs';
import { EditorConfig, ST_BUTTONS } from 'ngx-simple-text-editor';
import { DynamicAuditTrailComponent } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { TopNavigationComponent } from 'src/app/top-navigation/top-navigation.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { EditorComponent } from 'src/app/editor/editor.component';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';

export interface PopupData {
  title: string;
}

export interface DropDownInterface {
  codelistCode: any;
  codelistName: any;
}

@Component({
  selector: 'app-au-master',
  templateUrl: './au-master.component.html',
  styleUrls: ['./au-master.component.scss']
})

export class AuMasterComponent implements OnInit, OnDestroy, AfterViewInit {

  isProcessing = true;
  isNavigatingToDetails: boolean = false;
  auMasterData: any = {};

  selectedAuditGroup: any = []
  selectedAuditType: any = null;
  selectedAuditSubCategory: any = null;
  selectedAuditClassification: any = null;
  selectedRoutineIntervalUnit: any = [];
  displayVendor: boolean = false;
  displayDepartment: boolean = false;
  displayFunctionalAreaOrServices: boolean = false;

  functionalAreaOrServicesDropDown: any = [];
  selectedFunctionalAreaOrServices: any = [];
  functionalAreaOrServicesSelected: boolean = false;
  isIndeterminate: boolean = false;

  // Search text for the new multi-select search
  functionalAreaOrServicesTxt: string = '';

  dropDownForAuditGroup: any = [];
  dropDownForAuditType: any = [];
  dropDownForAuditSubCategory: any = [];
  dropDownForAuditClassification: any = [];
  dropDownForRoutineIntervalUnit: any = [];
  searchByAuditCategory: string = '';
  searchByAuditType: string = '';
  searchByClassification: string = '';

  // Added for dynamic AU_TYPE fetch
  detailsId: any = null;
  auditTypeList: any = [];

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  auditGroupDropDown: any = [];
  auditTypeDropDown: any = [];
  auditSubCategoryDropDown: any = [];
  auditClassificationDropDown: any = [];
  routineIntervalUnitDropDown: any = [];

  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, private readonly renderer: Renderer2,
    private readonly snackBar: MatSnackBar, public message: messageService, private readonly elem: ElementRef,
    public qmsservice: qmsService, public paginationService: PaginationService) {
  }

  private clickListener: () => void;
  private boundKeyDown = this.onKeyDown.bind(this);
  private boundKeyUp = this.onKeyUp.bind(this);
  private boundReset = this.resetKeyState.bind(this);
  ngOnInit() {

    this.message.breadcrumbData.firstLevel = "Home";
    if (this.qmsservice.SelectedGroupNameAndValue && this.qmsservice.SelectedGroupNameAndValue.length > 0) {
      this.message.breadcrumbData.secondLevel = this.qmsservice.moduleFullName + " > " + this.qmsservice.SelectedGroupNameAndValue[0].displayExp;
    } else {
      this.message.breadcrumbData.secondLevel = this.qmsservice.moduleFullName;
    }

    this.message.breadcrumbData.thirdLevel = '';
    this.message.breadcrumbData.fourthLevel = 'Audit Master';

    this.isProcessing = true;

    document.addEventListener('keydown', this.boundKeyDown);
    document.addEventListener('keyup', this.boundKeyUp);
    window.addEventListener('blur', this.boundReset);
    document.addEventListener('contextmenu', this.boundReset);

    forkJoin([
      this.appService.getQmsGroupsByModule("AU"),
      this.appService.getCodeListsByGroup('AUDIT_CLASSIFICATION'),
      this.appService.getCodeListsByGroup('AUDIT_ROUTINE_INTERVAL'),
      this.appService.getCodeListsByGroup('AUDIT_CATEGORY'),
      this.appService.getCodeListsByGroup('VENDOR_SERVICES_OFFERED')
    ]).subscribe(([groupData, classificationData, intervalUnitData, categoryData, vendorServices]) => {
      this.dropDownForAuditGroup = groupData;
      this.selectBoxForAuditGroup();

      this.dropDownForServicesOffered = vendorServices;
      this.dropDownForAuditClassification = classificationData;
      this.selectBoxForAuditClassification();

      this.dropDownForRoutineIntervalUnit = intervalUnitData;
      this.selectBoxForRoutineIntervalUnit();

      this.dropDownForAuditCategory = categoryData;
      this.selectBoxForAuditCategory();

      this.updateBreadcrumbAfterDataLoad();

      this.getcallMethod();

      // fetch AU_TYPE based on initial group selection
      if (this.qmsservice.SelectedGroupNameAndValue && this.qmsservice.SelectedGroupNameAndValue.length > 0) {
        this.fetchAuditTypes(this.qmsservice.SelectedGroupNameAndValue[0].valueExp);
      } else if (this.dropDownForAuditGroup?.length === 1) {
        this.fetchAuditTypes(this.dropDownForAuditGroup[0].groupId);
      }

    });
  }

  // Dynamic Audit Type Fetch Logic ---
  fetchAuditTypes(groupId: any) {
    this.appService.getQmsGroupDetailsByModule(groupId, this.qmsservice.moduleName || "AU").subscribe((groupData: any) => {
      this.detailsId = groupData.groupDetailId;
      this.appService.getCodeListsByGroup((this.qmsservice.moduleName || "AU") + "_TYPE").subscribe((response: any) => {
        this.appService.getTypeSettingsByGrpIdGrpDetailId(groupId, this.detailsId).subscribe((response: any) => {
          this.auditTypeList = [];
          for (const item of response) {
            if (item.type?.includes("Findings")) continue;
            this.auditTypeList.push(item);
          }

          this.dropDownForAuditType = this.auditTypeList;
          if (this.auMasterData.auditType) {
            for (const item of this.dropDownForAuditType) {
              if (item.type === this.auMasterData.auditType || item.codelistCode === this.auMasterData.auditType) {
                this.selectedAuditType = this.qmsservice.selectedAuditType = item.type || item.codelistCode;
                const typeValue = this.selectedAuditType.toLowerCase().trim();
                this.displayVendor = typeValue.includes('vendor');
                this.displayDepartment = !this.displayVendor;
              }
            }
          }
          setTimeout(() => { this.selectBoxForAuditType(); })
        })
      });
    });
  }

  updateBreadcrumbAfterDataLoad() {
    if (this.qmsservice.SelectedGroupNameAndValue && this.qmsservice.SelectedGroupNameAndValue.length > 0) {
      this.message.breadcrumbData.secondLevel = this.qmsservice.moduleFullName + " > " + this.qmsservice.SelectedGroupNameAndValue[0].displayExp;
    } else if (this.dropDownForAuditGroup?.length === 1) {
      this.qmsservice.SelectedGroupNameAndValue = [{
        valueExp: this.dropDownForAuditGroup[0].groupId,
        displayExp: this.dropDownForAuditGroup[0].groupName
      }];
      this.message.breadcrumbData.secondLevel = this.qmsservice.moduleFullName + " > " + this.dropDownForAuditGroup[0].groupName;
    }
  }

  dropDownForAuditCategory: any;
  selectBoxForAuditGroup() {
    this.auditGroupDropDown = [];
    this.auditGroupDropDown = this.dropDownForAuditGroup.map((item: { groupId: any; groupName: any; }) => ({
      valueExp: item.groupId,
      displayExp: item.groupName
    }));
  }
  auditCategoryDropDown: any;
  selectBoxForAuditCategory() {
    this.auditCategoryDropDown = [];
    this.auditCategoryDropDown = this.dropDownForAuditCategory?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })) || []
  }

  @ViewChild(TopNavigationComponent) topNavigationComponent!: TopNavigationComponent;
  openGroupMethod() {
    this.topNavigationComponent.opengroupPopup();
  }
  freezeAuditTypeDropDown: boolean = true;
  findingVendor: any = [];
  findingDepartment: any = [];
  onAuditCategoryDeselect() { }
  vendorPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  departmentPopupConfig = {
    width: '75%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  // --- Vendor Popup Properties ---
  @ViewChild('vendorPopup', { static: true }) vendorPopup: TemplateRef<any>;
  visibleVendorPopup: MatDialogRef<TemplateRef<any>>;

  searchByVendorName: string = '';
  searchByVendorCode: string = '';
  getCheckedVendorName: string = '';
  getCheckedVendorId: string = '';
  getCheckedServicesOffered: string = '';
  showVendorGrid: boolean = false;
  vendorList: any = [];
  tempSelectedVendor: any;
  tempSelectedDept: any;

  // For Vendor Selection
  onVendorSelectChange(vendor: any) {
    this.getCheckedVendorName = vendor.vendorName;
    this.getCheckedVendorId = vendor.vendorId;
    this.getCheckedServicesOffered = vendor.servicesOffered;
  }

  // For Department Selection
  onDepartmentSelectChange(dept: any) {
    this.getCheckedDepartmentName = dept.displayExp;
    this.getCheckedDepartmentCode = dept.valueExp;
    this.getSubgroupValues = dept.subGroup;
  }
  vendorGridCheckBox(event: any, vendor: any, index: number) {
    // Ensure only one checkbox is selected at a time
    this.vendorList.forEach((item: any, i: number) => {
      if (i !== index) item.vendorChildCheckBoxs = false;
    });

    if (event.target.checked) {
      vendor.vendorChildCheckBoxs = true;
      this.getCheckedVendorName = vendor.vendorName || '';
      this.getCheckedVendorId = vendor.vendorId || '';
      this.getCheckedServicesOffered = vendor.servicesOffered || '';
    } else {
      this.getCheckedVendorName = '';
      this.getCheckedVendorId = '';
      this.getCheckedServicesOffered = '';
    }
  }
  departmentGridCheckBox(event: any, department: any, index: number) {
    // Ensure only one checkbox is selected at a time
    this.departmentList.forEach((item: any, i: number) => {
      if (i !== index) item.departmentChildCheckBox = false;
    });

    if (event.target.checked) {
      department.departmentChildCheckBox = true;
      // Map to variables used by your existing selectDepartment() function
      this.getCheckedDepartmentName = department.codelistName || '';
      this.getCheckedDepartmentCode = department.codelistsPk?.codelistCode || '';
      this.getSubgroupValues = department.subgroupValues || '';
    } else {
      this.getCheckedDepartmentName = '';
      this.getCheckedDepartmentCode = '';
      this.getSubgroupValues = '';
    }
  }
  previousRow: any;

  // --- Department Popup Properties ---
  @ViewChild('departmentPopup', { static: true }) departmentPopup: TemplateRef<any>;
  visibleDepartmentPopup: MatDialogRef<TemplateRef<any>>;

  searchByCodeListName: string = '';
  searchByCodeListCode: string = '';
  searchByGroupName: string = '';
  getCheckedDepartmentName: string = '';
  getCheckedDepartmentCode: string = '';
  getSubgroupValues: string = '';
  departmentList: any = [];
  noResultFound: boolean = false;
  dropDownForFunctionalAreaOrServices: any = [];


  // --- VENDOR POPUP LOGIC ---
  openVendorPopup() {
    this.searchByVendorName = '';
    this.searchByVendorCode = '';
    this.vendorList = [];
    this.showVendorGrid = false;
    this.visibleVendorPopup = this.dialog.open(this.vendorPopup, this.vendorPopupConfig);
  }

  searchVendorFunc() {
    this.isProcessing = true;
    let data = {
      vendorName: this.searchByVendorName || null,
      vendorCode: this.searchByVendorCode || null,
      groupId: "" + this.qmsservice.selectedActivityGroupId
    }
    this.appService.fetchVendorListWithSearchCriteria(data).subscribe((vendorData: any) => {
      this.vendorList = vendorData;
      this.showVendorGrid = this.vendorList.length > 0;
      this.noResultFound = this.vendorList.length === 0;
      this.isProcessing = false;
    })
  }
  assignVendorFunctionalService(vendorServicesCodes: any) {
    if (!vendorServicesCodes || !this.dropDownForServicesOffered) return [];

    return this.dropDownForServicesOffered
      .filter((service: any) => vendorServicesCodes.includes(service.codelistCode))
      .map((x: any) => x.codelistName);
  }
  dropDownForServicesOffered: any = [];
  selectVendor() {
    this.auMasterData.vendorName = this.getCheckedVendorName;
    this.auMasterData.vendorId = this.getCheckedVendorId;
    const servicesArray = this.getCheckedServicesOffered ? this.getCheckedServicesOffered.split(',') : [];

    this.dropDownForFunctionalAreaOrServices = this.assignVendorFunctionalService(servicesArray);
    this.selectBoxForFunctionalAreaOrServices();

    this.displayFunctionalAreaOrServices = true;
    this.visibleVendorPopup.close();
    this.selectedFunctionalAreaOrServices = [];
    this.updateSelectAllState();

    const vendorField = document.getElementById('vendor-validation');
    if (vendorField) {
      vendorField.style.color = '#005c8a';
    }
  }

  // --- DEPARTMENT POPUP LOGIC ---
  openDepartmentPopup() {
    this.searchByCodeListName = '';
    this.searchByCodeListCode = '';
    this.departmentList = [];
    this.visibleDepartmentPopup = this.dialog.open(this.departmentPopup, this.departmentPopupConfig);
  }

  searchDepartmentFunc() {
    this.isProcessing = true;
    let data = {

      groupName: 'AUDIT_DEPARTMENT',
      codelistCode: this.searchByCodeListCode || null,
      codelistName: this.searchByCodeListName || null
    }
    this.appService.fetchDepartmentListWithSearchCriteria(data).subscribe((departmentData: any) => {
      this.departmentList = departmentData.filter((x: any) => x.isActive === 'Y');
      this.noResultFound = this.departmentList.length === 0;
      this.isProcessing = false;
    })
  }

  selectDepartment() {
    this.auMasterData.departmentName = this.getCheckedDepartmentName;
    this.auMasterData.departmentId = this.getCheckedDepartmentCode;

    this.dropDownForFunctionalAreaOrServices = this.getSubgroupValues?.split(',') || [];
    this.selectBoxForFunctionalAreaOrServices();

    this.displayFunctionalAreaOrServices = true;
    this.visibleDepartmentPopup.close();

    const deptField = document.getElementById('department-validation');
    if (deptField) {
      deptField.style.color = '#005c8a';
    }
  }

  // Formatter for the Functional Area multi-select
  selectBoxForFunctionalAreaOrServices() {
    this.functionalAreaOrServicesDropDown = this.dropDownForFunctionalAreaOrServices?.map((item: any) => ({
      valueExp: item,
      displayExp: item
    })) ?? [];
  }
  onAuditCategorySelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('category-validation', item);
      if (item) {
        this.isProcessing = true;
        this.displayVendor = this.displayDepartment = this.displayFunctionalAreaOrServices = false;

        // Reset dependent fields to maintain data integrity
        this.auMasterData.vendorId = '';
        this.auMasterData.vendorName = '';
        this.auMasterData.departmentId = '';
        this.auMasterData.departmentName = '';
        this.selectedFunctionalAreaOrServices = [];

        if (item.displayExp == 'External') {
          this.findingVendor = this.dropDownForAuditType?.filter((type: any) =>
            (type.codelistCode || type.type).toLowerCase().trim().includes('vendor')) || [];

          this.auditTypeDropDown = this.findingVendor.map((i: any) => ({
            valueExp: i.type || i.codelistCode,
            displayExp: i.type || i.codelistCode
          }));

          if (this.findingVendor.length > 0) {
            this.selectedAuditType = this.findingVendor[0].type || this.findingVendor[0].codelistCode;
            this.freezeAuditTypeDropDown = true;
            this.onAuditTypeSelect({ isUserInput: true }, { valueExp: this.selectedAuditType });
          }
        } else {
          const filteredDepts = this.dropDownForAuditType?.filter((type: any) =>
            !(type.codelistCode || type.type).toLowerCase().trim().includes('vendor')) || [];

          this.auditTypeDropDown = filteredDepts.map((i: any) => ({
            valueExp: i.type || i.codelistCode,
            displayExp: i.type || i.codelistCode
          }));

          if (filteredDepts.length === 1) {
            this.selectedAuditType = filteredDepts[0].type || filteredDepts[0].codelistCode;
            this.freezeAuditTypeDropDown = true;
            this.onAuditTypeSelect({ isUserInput: true }, { valueExp: this.selectedAuditType });
          } else {
            this.freezeAuditTypeDropDown = false;
          }
        }
        setTimeout(() => { this.isProcessing = false; }, 500);
      }
    }
  }

  onAuditGroupSelect() {
    this.handleDropDownValidation('group-validation', this.selectedAuditGroup)
    if (this.selectedAuditGroup && this.selectedAuditGroup.length > 0) {
      this.fetchAuditTypes(this.selectedAuditGroup[0].valueExp);
    }
  }

  onAuditGroupDeSelect() {
    this.handleDropDownValidation('group-validation', this.selectedAuditGroup)
  }

  cancelVendorPopup() {
    this.resetVendorFunc();
    this.visibleVendorPopup.close();
  }

  cancelDepartmentPopup() {
    this.resetDepartmentFunc();
    this.visibleDepartmentPopup.close();
  }
  resetVendorFunc() {
    this.searchByVendorName = '';
    this.searchByVendorCode = '';
    this.vendorList = [];
    this.showVendorGrid = false;
    this.noResultFound = false;
  }

  resetDepartmentFunc() {
    this.searchByCodeListName = '';
    this.searchByCodeListCode = '';
    this.departmentList = [];
    this.noResultFound = false;
  }
  selectBoxForAuditType() {
    this.auditTypeDropDown = [];
    this.auditTypeDropDown = this.dropDownForAuditType.map((item: any) => ({
      valueExp: item.type || item.codelistCode,
      displayExp: item.type || item.codelistName
    }));
  }

  onAuditTypeSelect(event: any, item: any) {
    if (event.isUserInput && item) {
      this.isProcessing = true;
      const typeValue = item.valueExp.toLowerCase().trim();

      // Visibility Flags
      this.displayVendor = typeValue.includes('vendor');
      this.displayDepartment = !this.displayVendor;

      // Reset nested dependencies
      this.selectedFunctionalAreaOrServices = [];
      this.displayFunctionalAreaOrServices = false;

      this.handleDropDownValidation('type-validation', item.valueExp);

      // Keep your existing API call logic
      const group = this.displayDepartment ? 'AUDIT_DEPARTMENT_NAME' : 'AUDIT_VENDOR_NAME';
      this.appService.getCodeListsByGroup(group).subscribe((data: any) => {
        this.dropDownForAuditSubCategory = data;
        this.selectBoxForAuditSubcategory();
        this.isProcessing = false;
      });
    }
  }

  toggleAllSelection(event: any) {
    if (event.checked) {
      // Select every item in the current dropdown list
      this.selectedFunctionalAreaOrServices = this.functionalAreaOrServicesDropDown.map((item: any) => item.valueExp);
    } else {
      // Clear selection
      this.selectedFunctionalAreaOrServices = [];
    }
    // Update indeterminate and selected flags
    this.updateSelectAllState();
  }
  updateSelectAllState(): void {
    const total = this.functionalAreaOrServicesDropDown ? this.functionalAreaOrServicesDropDown.length : 0;
    const selected = this.selectedFunctionalAreaOrServices ? this.selectedFunctionalAreaOrServices.length : 0;

    // Indeterminate: some selected, but not all
    this.isIndeterminate = selected > 0 && selected < total;

    // Select All Checked: only if count matches total and total > 0
    this.functionalAreaOrServicesSelected = total > 0 && selected === total;
  }
  onFunctionalAreaOrServicesSelect(event: any) {
    if (event.isUserInput) {
      setTimeout(() => { this.updateSelectAllState(); });
    }
  }

  selectBoxForAuditSubcategory() {
    this.auditSubCategoryDropDown = [];
    this.auditSubCategoryDropDown = this.dropDownForAuditSubCategory.map((item: DropDownInterface) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    }));
  }

  public isDropdownDisabled(): boolean {
    return this.selectedAuditType == null;
  }

  selectBoxForAuditClassification() {
    this.auditClassificationDropDown = [];
    this.auditClassificationDropDown = this.dropDownForAuditClassification.map((item: DropDownInterface) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    }));
  }

  showRoutineFields: boolean;
  onClassificationSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item.displayExp == 'Routine Audit') this.showRoutineFields = true;
      else this.showRoutineFields = false;
    }
  }

  onClassificationDeSelect(item: any) {
    if (this.showRoutineFields) this.showRoutineFields = false;
  }

  selectBoxForRoutineIntervalUnit() {
    this.routineIntervalUnitDropDown = [];
    this.routineIntervalUnitDropDown = this.dropDownForRoutineIntervalUnit.map((item: DropDownInterface) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    }));
  }

  onIntervalUnitSelect() {
    this.handleDropDownValidation('internal-unit-validation', this.selectedRoutineIntervalUnit)
  }

  onIntervalUnitDeSelect() {
    this.handleDropDownValidation('internal-unit-validation', this.selectedRoutineIntervalUnit)
  }

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  multiSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: true,
    allowSearchFilter: true,
    singleSelection: false,
  };

  popupTitle: string | null = 'title';
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('angularEditorTextarea', { static: true }) angularEditorTextarea: TemplateRef<any>;
  visibleangularEditorTextareaPopup: MatDialogRef<TemplateRef<any>>;

  angularEditorTextareaConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  addAndEditPopupConfig = {
    width: '75%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  deletePopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  popupDataTitle: PopupData = {
    title: ''
  };

  visibleAddButton: boolean;
  visibleEditButton: boolean;
  operationFlag: any;

  openAddPopup() {
    this.visibleAddButton = true;
    this.visibleEditButton = this.showRoutineFields = false;
    [
      this.auMasterData.description,
      this.auMasterData.auditPurpose,
      this.auMasterData.auditScope,
      this.auMasterData.auditReferences,
      this.auMasterData.remarks
    ] = ["", "", "", "", ""];

    [
      this.selectedAuditGroup,
      this.selectedAuditType,
      this.selectedAuditSubCategory,
      this.selectedAuditClassification,
      this.selectedRoutineIntervalUnit
    ] = [[], null, null, null, []]
    this.selectedAuditGroup = this.qmsservice.SelectedGroupNameAndValue;
    this.auMasterData.routineInterval = null;
    this.auMasterData.vendorName = '';
    this.auMasterData.vendorId = '';
    this.auMasterData.departmentName = '';
    this.auMasterData.departmentId = '';

    this.selectedFunctionalAreaOrServices = [];
    this.dropDownForFunctionalAreaOrServices = [];
    this.functionalAreaOrServicesSelected = false;
    this.isIndeterminate = false;

    this.displayVendor = false;
    this.displayDepartment = false;
    this.displayFunctionalAreaOrServices = false;

    this.auMasterData.isActive = true;
    this.operationFlag = 'ADD';
    this.popupDataTitle.title = "Add Audit Master";
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  editingAuMasterId: any;
  openEditPopup(auMasterEditingData: any) {
    this.isProcessing = true;
    this.visibleAddButton = false;
    this.visibleEditButton = true;
    this.operationFlag = 'EDIT';
    this.functionalAreaOrServicesSelected = false;
    this.popupDataTitle.title = "Edit Audit Master";
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
    this.editingAuMasterId = auMasterEditingData.AUDIT_MASTER_ID;
    this.appService.getAuMasterByAuMasterId(this.editingAuMasterId).subscribe((data: any) => {
      data.isActive = data.isActive == "Y";

      this.auMasterData = data;

      if (data.groupId) {
        const matchingGroup = this.dropDownForAuditGroup.find((item: any) => item.groupId == data.groupId);
        if (matchingGroup) {
          this.selectedAuditGroup = [{
            valueExp: matchingGroup.groupId,
            displayExp: matchingGroup.groupName
          }];
          // Trigger dynamic fetch on edit map
          this.fetchAuditTypes(matchingGroup.groupId);
        }
      }

      if (data.subcategory) {
        const matchingSubCategory = this.dropDownForAuditCategory.find((item: any) => item.codelistCode == data.subcategory);
        if (matchingSubCategory) {
          this.selectedAuditSubCategory = matchingSubCategory.codelistCode;
        }
      }
      if (data.auditClassification) {
        const matchingClassification = this.dropDownForAuditClassification.find((item: any) => item.codelistCode == data.auditClassification);
        if (matchingClassification) {
          this.selectedAuditClassification = matchingClassification.codelistCode;

          if (matchingClassification.codelistName == 'Routine Audit') this.showRoutineFields = true;
          else this.showRoutineFields = false;
        }
      }

      if (data.routineIntervalUnit) {
        const matchingIntervalUnit = this.dropDownForRoutineIntervalUnit.find((item: any) => item.codelistCode == data.routineIntervalUnit);
        if (matchingIntervalUnit) {
          this.selectedRoutineIntervalUnit = [{
            valueExp: matchingIntervalUnit.codelistCode,
            displayExp: matchingIntervalUnit.codelistName
          }]
        }
      }

      if (data.vendorId) {
        this.displayVendor = true;
        this.displayDepartment = false;
        this.auMasterData.vendorId = data.vendorId;
        this.appService.getQmsVendorsVwDetailsByVendorId(
          data.vendorId,
        ).subscribe((vendorData: any) => {
          this.auMasterData.vendorName = vendorData.vendorName;
        });
      }
      if (data.functionalAreaOrServices) {
        this.displayFunctionalAreaOrServices = true;
        this.selectedFunctionalAreaOrServices = data.functionalAreaOrServices.split(',');

        this.dropDownForFunctionalAreaOrServices = this.selectedFunctionalAreaOrServices;
        this.selectBoxForFunctionalAreaOrServices();
        this.updateSelectAllState();
      } else {
        this.displayFunctionalAreaOrServices = false;
        this.selectedFunctionalAreaOrServices = [];
      }

      if (data.auditDepartment) {
        data.departmentName = data.auditDepartment;
      }

      this.isProcessing = false;
    })
  }

  deletingAuMasterId: any;
  openDeletePopup(auMasterDeletingData: any) {
    this.operationFlag = 'DELETE';
    this.popupDataTitle.title = "Delete Audit Master";
    this.deletingAuMasterId = auMasterDeletingData.AUDIT_MASTER_ID;
    this.auMasterData.deleteReason = '';
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  addAndEditFunction(auMasterData: any) {
    const validations = [
      { condition: this.selectedAuditGroup.length == 0, id: 'group-validation' },
      { condition: this.selectedAuditSubCategory == null, id: "category-validation" },
      { condition: this.selectedAuditType == null, id: "type-validation" },
      { condition: !this.auMasterData.description, id: "description-validation" },
    ]
    if (this.displayVendor) {
      validations.push({ condition: !this.auMasterData.vendorId, id: 'vendor-validation' });
    }

    if (this.displayDepartment) {
      validations.push({ condition: !this.auMasterData.departmentName, id: 'department-validation' });
    }

    const invalidIds: string[] = validations.filter((validation) => validation.condition).map((validation) => validation.id);
    const functionalAreaPayload = this.selectedFunctionalAreaOrServices ? this.selectedFunctionalAreaOrServices.join(',') : '';

    if (invalidIds.length > 0) {
      this.manageValidations(invalidIds);
    } else {
      this.isProcessing = true;
      let data = {
        groupId: this.selectedAuditGroup[0]?.valueExp ?? null,
        description: auMasterData.description,
        auditType: this.selectedAuditType ?? null,
        subcategory: this.selectedAuditSubCategory ?? null,
        auditClassification: this.selectedAuditClassification ?? null,
        auditPurpose: this.auMasterData.auditPurpose,
        auditScope: this.auMasterData.auditScope,
        auditReferences: this.auMasterData.auditReferences,
        remarks: this.auMasterData.remarks,
        functionalAreaOrServices: functionalAreaPayload,
        vendorName: this.auMasterData.vendorName || '',
        vendorId: this.auMasterData.vendorId || '',
        auditDepartment: this.auMasterData.departmentId || this.auMasterData.auditDepartment || '',
        departmentId: this.auMasterData.departmentId || this.auMasterData.auditDepartment || '',
        isActive: this.auMasterData.isActive ? "Y" : "N",
      }

      if (this.operationFlag == 'ADD') {
        this.appService.createAuMaster(data).subscribe({
          next: (Response: any) => {
            if (Response.resultType == "S") {
              this.ngOnInit();
              this.visibleAddAndEditPopup.close();
              this.showSnackBar(Response.result, Response.resultType);
            } else {
              this.showSnackBar(Response.result, Response.resultType);
              this.isProcessing = false;
            }
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      } else {
        const modifiedData = {
          ...data,
          auditMasterId: this.editingAuMasterId
        }
        this.appService.updateAuMaster(modifiedData).subscribe({
          next: (Response: any) => {
            if (Response.resultType == "S") {
              this.ngOnInit();
              this.visibleAddAndEditPopup.close();
              this.showSnackBar(Response.result, Response.resultType);
            } else {
              this.showSnackBar(Response.result, Response.resultType);
              this.isProcessing = false;
            }
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      }
    }
  }

  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
  }

  deleteFunction(auMasterData: any) {
    if (this.auMasterData.deleteReason) {
      this.isProcessing = true;
      let data = {
        auditMasterId: this.deletingAuMasterId,
        deleteReason: auMasterData.deleteReason
      }

      this.appService.deleteAuMaster(data).subscribe({
        next: (Response: any) => {
          if (Response.resultType == "S") {
            this.ngOnInit();
            this.visibleDeletePopup.close();
          } else {
            this.isProcessing = false;
          }
          this.showSnackBar(Response.result, Response.resultType);
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    } else {
      const field = document.getElementById('delete-reason-validation') as HTMLInputElement;
      field.style.color = 'red';
    }
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  validateNumberFields(event: KeyboardEvent) {
    const forbiddenKeys = ['E', 'e', '-', '*', '+', '.'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  onNgModuleChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = items ? '' : 'red';
  }

  handleDropDownValidation(fieldId: string, selectedItems: any) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    if (field) {
      if (selectedItems == null || selectedItems === '' || (Array.isArray(selectedItems) && selectedItems.length === 0)) {
        field.style.color = 'red';
      } else {
        field.style.color = '#005c8a';
      }
    }
  }

  manageValidations(elementIds: string[]) {
    elementIds.forEach((elementId) => {
      const element = document.getElementById(elementId) as HTMLInputElement;
      element.style.color = 'red';
    })
  }

  config: EditorConfig = {
    buttons: [],
  };

  config1: EditorConfig = {
    buttons: ST_BUTTONS,
  };

  editorValue: any;
  textareaEditorTitle: any;
  openEditor(value: string) {
    this.editorValue = "";
    this.textareaEditorTitle = "";
    this.textareaEditorTitle = value;

    const formattedValue = value
      .split(' ')
      .map((word, index) => index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join('');

    this.editorValue = this.auMasterData[formattedValue] || '';
    this.textareaEditorTitle = value;
    this.visibleangularEditorTextareaPopup = this.dialog.open(this.angularEditorTextarea, this.angularEditorTextareaConfig);
  }

  okAngularEditorData(editorValue: any) {
    console.log(editorValue);
    const formattedTitle = this.textareaEditorTitle
      .split(' ')
      .map((word: string, index: number) => index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join('');

    this.auMasterData[formattedTitle] = this.editorValue;
    this.visibleangularEditorTextareaPopup.close();
  }

  cancelAngularEditorData() {
    this.visibleangularEditorTextareaPopup.close();
  }

  showSnackBar(message: string, type: string) {
    this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ? this.message.breadcrumbData.thirdLevel : this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    this.snackbarRef.onAction().subscribe(() => {
      this.snackbarRef.dismiss();
    });
  }

  searchText: any;
  searchValue: any;
  _temp: any = {};
  columnLists: any = {};
  auMasterDataForGrid: any = [];
  makeStickyColumns: any;
  dataTypeList: any = [];
  visibleDataGrid: boolean = false;
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  pager: any = {};
  pagedItems: any[];
  error = '';

  getcallMethod() {
    this.isProcessing = true;
    const data = {

      gridName: "AU_MASTER"
    }
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        response.orderByClause = response.orderByClause ? response.orderByClause : "";
        this.makeStickyColumns = response.fixedFieldCnt;
        const data1: any = {

          gridName: "QMS_AU_MASTER_VW",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn == null ? "" : response.invisibleColumn + ",ROUTINE_INTERVAL,ROUTINE_INTERVAL_UNIT",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          manualEntryDataFields: response.manualEntryDataFields,
          groupId: "" + this.qmsservice.selectedActivityGroupId,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || ""
        }

        this.reportObj = { ...data1, ...data };

        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {

            this.auMasterDataForGrid = response1;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");

            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];

            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }

            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];

            for (const element of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(element + 'px');
            }

            for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
              for (const element of this.columnLists.invisibleColumnarray) {
                if (this.columnLists.columnsListarray[y] == element) {
                  this.columnLists.columnsListarray.splice(y, 1);
                  this.columnLists.fieldColumnarray.splice(y, 1);
                  this.columnLists.fieldSizeListArray.splice(y, 1);
                }
              }
            }

            let tableData = {
              tablename: data1.tableOrViewName
            };

            this.columnLists.columnsListarray1 = [];

            this.appService.tableFieldsDataType(tableData).subscribe({
              next: (response2: any) => {

                this.dataTypeList = response2;

                for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                  this.columnLists.columnsListarray1.push({});
                  this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                  this.columnLists.columnsListarray1[m].dataType = "textbox";
                  this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;

                  for (const element of this.dataTypeList) {
                    if (element.columnName == this.columnLists.columnsListarray[m]) {
                      this.columnLists.columnsListarray1[m].dataType = element.fieldType;
                    }
                  }
                }

                for (const row of this.auMasterDataForGrid) {
                  for (const element of this.dataTypeList) {
                    if (element.fieldType == 'CHECKBOX') {
                      row[element.columnName] = row[element.columnName] == "Y";
                    }
                  }
                }

                this.calculateTotalPages = this.collectionSize / this.perPage;
                this.pager.totalPages = undefined;
                this.setPage(1, 0);
                this.labelcall();
              }
            });

            this.message.gridList = this.auMasterDataForGrid;
            this.collectionSize = this.auMasterDataForGrid.length;
            this.totalPages = Math.ceil(this.auMasterDataForGrid.length / this.itemsPerPage);
            this.isProcessing = false;

          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });

        this.isProcessing = false;

      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  label: any = [];
  dynamicLabel: any = null;
  labelcall() {
    this.isProcessing = true;
    const data = {
      tableName: this.reportObj.tableOrViewName,
      moduleName: null,
      gridName: this.reportObj.gridName,
      groupId: this.qmsservice.selectedActivityGroupId
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (data: any) => {
        this.label = data;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = user.changedFieldName;
          return acc;
        }, {});
        console.log(this.dynamicLabel);
        this.isProcessing = false;
      },
      error: (error: any) => {
        this.isProcessing = false;
      }
    });
  }

  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.auMasterDataForGrid.length, page, this.perPage, targetpage);
    this.pagedItems = this.auMasterDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    this.isProcessing = false;
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.auMasterDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.auMasterDataForGrid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  onClick(event: any) {

  }

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;
  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      this.childCheckBoxs = true;
      for (const element of this.auMasterDataForGrid) {
        element.childCheckBoxs = true;
      }
    } else {
      this.childCheckBoxs = false;
      for (const element of this.auMasterDataForGrid) {
        element.childCheckBoxs = false;
      }
    }
  }

  previousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.previousSelectedValue != undefined) {
        this.auMasterDataForGrid[this.previousSelectedValue].childCheckBoxs = false;
      }
      list.childCheckBoxs = true;
    } else {
      list.childCheckBoxs = false;
    }
    this.previousSelectedValue = idx;
  }

  refreshGridData() {
    this.getcallMethod();
  }

  sortedColumn: string = '';
  sortedDisplayColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    this.isProcessing = true;
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortedDisplayColumn = list.fieldColumnarray;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.auMasterDataForGrid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;
  auditTrail: any = {};
  openAuditTrail(viewType: any, aumaster: any) {
    this.auditTrail.refNo = viewType == 'overAll' ? null : aumaster.AUDIT_MASTER_ID;
    this.auditTrail.gridName = 'AU_MASTER';
    this.auditTrail.report_And_Popup_Name = 'Audit Master Audit Trail';
    this.dynamicAuditTrailComponent.triggerTrail(aumaster);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = { ...this.reportObj };
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = 'Audit Master Report';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  @ViewChild('viwerClobPopup', { static: true }) viwerClobPopup: TemplateRef<any>;
  visibleviwerClobPopup: MatDialogRef<TemplateRef<any>>;
  aviwerlPopupConfig = {
    width: '80%',
    height: '80%',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  }

  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  getClobData(list: any, colunName: any) {
    this.isProcessing = true;
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: 'QMS_AU_MASTER_VW',
      columnName: colunName
    }
    this.htmlContent = "";
    this.appService.getClobToViewAudit(docObj).subscribe({
      next: (Response: any) => {
        console.log(Response.result);
        this.htmlContent = Response.result;
        this.editorComponent.openEditor(this.htmlContent, colunName);
      },
      error: (error) => {
        console.log(error);
      }
    });
    this.isProcessing = false;

  }
  htmlContent: any;
  closeHtmlContent() {
    this.visibleviwerClobPopup.close();
  }

  snackbarRef: any;
  ngAfterViewInit() {
    /* Listener for document click */
    this.clickListener = this.renderer.listen('document', 'click', () => {
      if (this.snackbarRef) {
        this.snackbarRef.dismiss();
      }
    });
  }

  ctrlPressed: boolean = false;
  shiftPressed: boolean = false;
  ngOnDestroy() {
    if (this.isNavigatingToDetails) {
      return;
    }
    this.message.breadcrumbData.thirdLevel = '';
    this.message.breadcrumbData.fourthLevel = '';

    document.removeEventListener('keydown', this.boundKeyDown);
    document.removeEventListener('keyup', this.boundKeyUp);
    window.removeEventListener('blur', this.boundReset);
    document.removeEventListener('contextmenu', this.boundReset);

    /* Cleaning up the listeners */
    if (this.clickListener) {
      this.clickListener();
    }
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = true;
    } else if (event.key === 'Shift') {
      this.shiftPressed = true;
    }
  }

  onKeyUp(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = false;
    } else if (event.key === 'Shift') {
      this.shiftPressed = false;
    }
  }

  resetKeyState() {
    this.ctrlPressed = false;
    this.shiftPressed = false;
  }

  onPaste(event: ClipboardEvent) {
    const isAllowedPaste = this.ctrlPressed && this.shiftPressed;
    if (!isAllowedPaste) {
      event.preventDefault();
      this.showSnackBar("You can't perform this operation. Please use Ctrl + Shift + V to paste the content", 'E');
    }
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, null, 0)
  }

  onChildValueEmitted() {
    this.getcallMethod();
  };

  public focusEmpty(): void {
    console.log();
  }


}
